import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'src/app/models/user/user';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { UserAutocompleteDataLoaderService } from 'src/app/services/autocomplete-data-loader/user-autocomplete-data-loader.service';
import { Platform } from '@ionic/angular'; 
import { SplashScreen } from '@capacitor/splash-screen';
import { Title } from '@angular/platform-browser';
import { DashboardUserItemSummaryComponent } from 'src/app/components/dashboard-user-item-summary/dashboard-user-item-summary.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {
  @ViewChild('summary', { static: true }) summary: DashboardUserItemSummaryComponent;

  title: string = 'Dashboard';
  user: User;

  constructor(
    private titleService: Title,
    private platform: Platform,
    private userData: UserDataService,
    public userAutoCompDataLoader: UserAutocompleteDataLoaderService
    ) {
  }

  ngOnInit() {
  }
  
  ionViewWillEnter() {
    this.userData.getUser().then(u => this.user = u);
    this.titleService.setTitle(this.title);
    this.platform.ready().then(() => SplashScreen.hide());
    this.summary.loadDashboardItemsObservable().subscribe();
  }
}
